import { ValueOf } from '@/types/sharedTypes';

export const USER_ROLE_MAP = {
  OPCO: 'opco_user',
  ORG_ADMIN: 'org_admin',
  MASTER_ADMIN: 'master_admin',
  RECIPIENT: 'recipient_user',
  EXECUTOR: 'executor',
  DEPOSITOR: 'depositor',
} as const;

export type UserRoleType = ValueOf<typeof USER_ROLE_MAP>;

export type TokenUserRoleType = {
  organization_user: 'master_admin' | 'org_admin';
  executor: 'executor';
  depositor: 'depositor';
  recipient_user: 'recipient_user';
  opco_user: 'opco_user';
};

export type UserRolesStatusType = {
  [key in UserRoleType]?: {
    subrole: string;
    status: 'active' | 'blocked';
  };
};

export const ORG_ADMIN_ROLE = {
  MASTER_ADMIN: 'master_admin',
  ORG_ADMIN: 'org_admin',
} as const;

export type OrgAdminRoleType = ValueOf<typeof ORG_ADMIN_ROLE>;

export const USER_ROLE_LABEL_MAP = {
  [USER_ROLE_MAP.OPCO]: 'OpCo',
  [USER_ROLE_MAP.RECIPIENT]: 'Recipient',
  [USER_ROLE_MAP.EXECUTOR]: 'Executor',
  [USER_ROLE_MAP.DEPOSITOR]: 'Depositor',
  [USER_ROLE_MAP.MASTER_ADMIN]: 'Master Admin',
  [USER_ROLE_MAP.ORG_ADMIN]: 'Admin',
};

export const ORGANIZATION_USER_STATUS = {
  ACTIVE: 'active',
  BLOCKED: 'blocked',
  INVITED: 'invited',
  UNCONFIRMED: 'unconfirmed',
} as const;

export type OrganizationUserStatusType = ValueOf<typeof ORGANIZATION_USER_STATUS>;

export const ORGANIZATION_USER_ROLE_LABEL_MAP = {
  [ORG_ADMIN_ROLE.ORG_ADMIN]: 'Admin',
  [ORG_ADMIN_ROLE.MASTER_ADMIN]: 'Master Admin',
};
